import React, {FC} from 'react'
import ReactDOM from 'react-dom'
import "../Modal/Modal.css"
import { CSSTransition } from 'react-transition-group'
interface ModalProps{
  isShowing: boolean,
  hideModal:(()=>void),
  children?:JSX.Element
}

export default function Modal({isShowing,hideModal,children }:ModalProps) {
  const ModalClass = isShowing ? "Modal-Show" : "Modal-Hidden"
  return ReactDOM.createPortal(
    <CSSTransition unmountOnExit in={isShowing} timeout={300} classNames="Modal">
      <div className={`Modal-Container ${ModalClass}`}>
      <div className='Modal-Content'>
        <button className='Close-Btn' onClick={hideModal}>Close</button>
        {children}
      </div>
    </div>
    </CSSTransition>
    
    ,document.querySelector("#root") as HTMLElement)

}
